import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_CONFIRMATION,
  CHANGE_PASSWORD_RESET_EMAIL,
  CHANGE_SIGN_IN_EMAIL,
  CHANGE_SIGN_IN_PASSWORD,
  FAILURE_AUTHENTICATION,
  FAILURE_CREATE_USER,
  FAILURE_DELETE_USER,
  FAILURE_FETCH_USERS,
  FAILURE_INITIALIZE_CONFIRMATION,
  FAILURE_INITIALIZE_RECONFIRMATION,
  FAILURE_REGISTER,
  FAILURE_RESET_PASSWORD,
  FAILURE_SIGN_IN,
  FAILURE_SIGN_OUT,
  FAILURE_UPDATE_PASSWORD,
  FAILURE_UPDATE_USER,
  FAILURE_VERIFY_SESSION,
  REQUEST_CREATE_USER,
  REQUEST_DELETE_USER,
  REQUEST_FETCH_USERS,
  REQUEST_INITIALIZE_CONFIRMATION,
  REQUEST_INITIALIZE_RECONFIRMATION,
  REQUEST_REGISTER,
  REQUEST_RESET_PASSWORD,
  REQUEST_SIGN_IN,
  REQUEST_SIGN_OUT,
  REQUEST_UPDATE_PASSWORD,
  REQUEST_UPDATE_USER,
  REQUEST_VERIFY_SESSION,
  RESET_USERS_STATE,
  SUCCESS_AUTHENTICATION,
  SUCCESS_CREATE_USER,
  SUCCESS_DELETE_USER,
  SUCCESS_FETCH_USERS,
  SUCCESS_INITIALIZE_CONFIRMATION,
  SUCCESS_INITIALIZE_RECONFIRMATION,
  SUCCESS_REGISTER,
  SUCCESS_RESET_PASSWORD,
  SUCCESS_SIGN_IN,
  SUCCESS_SIGN_OUT,
  SUCCESS_UPDATE_PASSWORD,
  SUCCESS_UPDATE_USER,
  TOGGLE_PRIVACY_POLICY,
  TOGGLE_SESSION_EXTENDED,
} from 'actions/actionTypes';
import { ErrorTypes } from 'types/app';
import {
  SuccessAuthenticationPayloadTypes,
  SuccessSignInPayloadTypes,
  UserInputTypes,
  UserTypes,
} from 'types/backend/user';

export const requestVerifySession = () => ({
  type: REQUEST_VERIFY_SESSION,
});

export const successAuthentication = (payload: SuccessAuthenticationPayloadTypes) => ({
  type: SUCCESS_AUTHENTICATION,
  payload,
});

export const failureAuthentication = () => ({
  type: FAILURE_AUTHENTICATION,
});

export const failureVerifySession = () => ({
  type: FAILURE_VERIFY_SESSION,
});

export const changeSignInEmail = (signInEmail: string) => ({
  type: CHANGE_SIGN_IN_EMAIL,
  signInEmail,
});

export const changeSignInPassword = (signInPassword: string) => ({
  type: CHANGE_SIGN_IN_PASSWORD,
  signInPassword,
});

export const toggleSessionExtended = (flag: boolean) => ({
  type: TOGGLE_SESSION_EXTENDED,
  flag,
});

export const requestSignIn = () => ({
  type: REQUEST_SIGN_IN,
});

export const successSignIn = (payload: SuccessSignInPayloadTypes) => ({
  type: SUCCESS_SIGN_IN,
  payload,
});

export const failureSignIn = () => ({
  type: FAILURE_SIGN_IN,
});

export const requestSignOut = () => ({
  type: REQUEST_SIGN_OUT,
});

export const successSignOut = () => ({
  type: SUCCESS_SIGN_OUT,
});

export const failureSignOut = () => ({
  type: FAILURE_SIGN_OUT,
});

export const changePasswordResetEmail = (passwordResetEmail: string) => ({
  type: CHANGE_PASSWORD_RESET_EMAIL,
  passwordResetEmail,
});

export const requestResetPassword = () => ({
  type: REQUEST_RESET_PASSWORD,
});

export const successResetPassword = () => ({
  type: SUCCESS_RESET_PASSWORD,
});

export const failureResetPassword = () => ({
  type: FAILURE_RESET_PASSWORD,
});

export const changePassword = (password: string) => ({
  type: CHANGE_PASSWORD,
  password,
});

export const changePasswordConfirmation = (passwordConfirmation: string) => ({
  type: CHANGE_PASSWORD_CONFIRMATION,
  passwordConfirmation,
});

export const requestUpdatePassword = () => ({
  type: REQUEST_UPDATE_PASSWORD,
});

export const successUpdatePassword = (payload: SuccessSignInPayloadTypes) => ({
  type: SUCCESS_UPDATE_PASSWORD,
  payload,
});

export const failureUpdatePassword = (error: ErrorTypes) => ({
  type: FAILURE_UPDATE_PASSWORD,
  error,
});

export const togglePrivacyPolicy = (flag: boolean) => ({
  type: TOGGLE_PRIVACY_POLICY,
  flag,
});

export const requestInitializeConfirmation = () => ({
  type: REQUEST_INITIALIZE_CONFIRMATION,
});

export const successInitializeConfirmation = (payload: { email: string; id: string }) => ({
  type: SUCCESS_INITIALIZE_CONFIRMATION,
  payload,
});

export const failureInitializeConfirmation = () => ({
  type: FAILURE_INITIALIZE_CONFIRMATION,
});

export const requestInitializeReconfirmation = () => ({
  type: REQUEST_INITIALIZE_RECONFIRMATION,
});

export const successInitializeReconfirmation = (payload: { email: string; id: string }) => ({
  type: SUCCESS_INITIALIZE_RECONFIRMATION,
  payload,
});

export const failureInitializeReconfirmation = () => ({
  type: FAILURE_INITIALIZE_RECONFIRMATION,
});

export const requestRegister = () => ({
  type: REQUEST_REGISTER,
});

export const successRegister = (payload: SuccessSignInPayloadTypes) => ({
  type: SUCCESS_REGISTER,
  payload,
});

export const failureRegister = (error: ErrorTypes) => ({
  type: FAILURE_REGISTER,
  error,
});

export const requestFetchUsers = (pageNumber?: number) => ({
  type: REQUEST_FETCH_USERS,
  pageNumber,
});

export const successFetchUsers = (payload: UserTypes[], size: number, pageNumber?: number) => ({
  type: SUCCESS_FETCH_USERS,
  payload,
  size,
  pageNumber,
});

export const failureFetchUsers = () => ({
  type: FAILURE_FETCH_USERS,
});

export const requestCreateUser = (params: UserInputTypes) => ({
  type: REQUEST_CREATE_USER,
  params,
});

export const successCreateUser = (payload: UserTypes) => ({
  type: SUCCESS_CREATE_USER,
  payload,
});

export const failureCreateUser = () => ({
  type: FAILURE_CREATE_USER,
});

export const requestUpdateUser = (params: UserInputTypes) => ({
  type: REQUEST_UPDATE_USER,
  params,
});

export const successUpdateUser = (payload: UserTypes) => ({
  type: SUCCESS_UPDATE_USER,
  payload,
});

export const failureUpdateUser = () => ({
  type: FAILURE_UPDATE_USER,
});

export const requestDeleteUser = (id: string) => ({
  type: REQUEST_DELETE_USER,
  id,
});

export const successDeleteUser = (id: string) => ({
  type: SUCCESS_DELETE_USER,
  id,
});

export const failureDeleteUser = () => ({
  type: FAILURE_DELETE_USER,
});

export const resetUsersState = () => ({
  type: RESET_USERS_STATE,
});
